import { HTMLAttributes, ReactNode } from 'react';
import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { LocationOn as LocationOnIcon } from '@mui/icons-material';
import { MapIcon } from 'features/mapping/mapping.types';
import { useStyles } from './styles';

type SearchOptionItemProps = {
  optionName: string;
  primaryText: ReactNode;
  secondaryText: string;
  optionProps?: HTMLAttributes<HTMLLIElement>;
  imgAlt?: string;
  icon?: MapIcon;
  className?: string;
  opacity?: number;
};

/**
 * @deprecated by `<SearchResultRow />` in `useMapSearch()`
 */
export const SearchOptionItem = (props: SearchOptionItemProps): JSX.Element => {
  const {
    optionName,
    primaryText,
    secondaryText,
    optionProps = {},
    imgAlt,
    icon,
    className,
    opacity = 1,
  } = props;
  const { classes } = useStyles();

  return (
    <ListItemButton
      component="li"
      {...optionProps}
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        padding: 1,
      }}
      className={className}
      aria-label={optionName}
    >
      <ListItemIcon sx={{ minWidth: 32 }}>
        {icon ? (
          <Box className={classes.geoEventIcon} sx={{ width: 3 }}>
            <img
              src={icon.data}
              alt={imgAlt}
              width={16}
              height="auto"
              style={{ opacity }}
            />
          </Box>
        ) : (
          <LocationOnIcon className={classes.itemIcon} />
        )}
      </ListItemIcon>
      <ListItemText
        primary={primaryText}
        secondary={
          <Box className={classes.itemSecondary}>
            <Typography
              color="textSecondary"
              variant="subtitle1"
              className={classes.itemSecondaryText}
            >
              {secondaryText}
            </Typography>
          </Box>
        }
        className={classes.itemText}
        slotProps={{
          secondary: { component: 'div' },
        }}
      />
    </ListItemButton>
  );
};
